import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const NetworksAdd = ({ setupdateData, handleClose }) => {
  const [errorMessage, setErrorMessage] = useState({});
  const refSubmitDis = useRef();
  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage("");
    refSubmitDis.current.setAttribute("disabled", true);
    const formData = new FormData(event.currentTarget);
    const InpuData = Object.fromEntries(formData);
    try {
      fetch("https://api.wlfmobile.com/api/admin/withdrawal/network/store", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(InpuData),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success === false) {
            setErrorMessage(data?.errors);
          } else {
            toast.success(`${data?.message}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setupdateData(data?.data);
            handleClose();
          }
          refSubmitDis.current.removeAttribute("disabled");
        })
        .catch((error) => console.log(error));
    } catch (error) {}
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Add Coin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div class="modal-body">
            <div class="form-group">
              <label htmlFor="name" class="required">
                Coin Name
              </label>
              <input
                type="text"
                class="form-control"
                name="name"
                required=""
                id="name"
              />
              {errorMessage?.name && (
                <span className="text-danger pt-2">
                  {errorMessage?.name?.msg}
                </span>
              )}
            </div>

            <button
              type="submit"
              class="btn btn-primary w-100 h-45"
              ref={refSubmitDis}
            >
              Submit
            </button>
          </div>
        </form>
      </Modal.Body>
    </>
  );
};

export default NetworksAdd;
